import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import Auth from "./views/auth";
import rootReducer from "./reducers";
import reportWebVitals from './reportWebVitals';

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.css";
import "antd/dist/antd.css";

const store = createStore(rootReducer);

render(
  <Provider store={store}>
    <Auth />
  </Provider>,
  document.getElementById("app")
);

reportWebVitals();
